
"use client"

import { forgotPassword } from '@/app/auth/actions'
import { LoaderButton } from '@/components/shared/core'
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useActionState } from "react"

export function ForgotPasswordForm() {
    const initialState = {
        message: ''
    }
    const [formState, formAction, isPending] = useActionState(forgotPassword, initialState)
    return (<>
        <form action={formAction}>
            <div className="grid gap-2">
                <Label htmlFor="email">Email</Label>
                <Input
                    id="email"
                    type="email"
                    placeholder="m@example.com"
                    name="email"
                    required
                />
            </div>
            <LoaderButton isPending={isPending} text={"Reset Password"} pendingText="Submitting..."></LoaderButton>
            {formState?.message && (
                <p className="text-sm text-red-500 text-center py-2">{formState.message}</p>
            )}
        </form >
    </>)
}